import { Auth } from '../auth.service';
import { logger } from '../logger.service';
import { BusEvent, EBusEvent } from '../bus-event/bus-event.service';
import {
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosHeaders,
} from 'axios';

export const hubInterceptor = {
  success: (config: InternalAxiosRequestConfig) => {
    const jwtHubToken = Auth.getHubToken();

    if (!jwtHubToken) {
      logger.critical('There is no jwtToken for HUB');
      throw new Error('There is no jwtToken for HUB');
    }

    if (!config.headers) {
      config.headers = new AxiosHeaders();
    }
    config.headers.Authorization = `Bearer ${jwtHubToken}`;

    return config;
  },
  error: (error: AxiosError) => {
    return Promise.reject(error);
  },
};

export const apiInterceptor = {
  success: (config: InternalAxiosRequestConfig) => {
    const jwtToken = Auth.getDynJwtToken();

    if (!jwtToken) {
      logger.critical('There is no jwtToken for API');
      throw new Error('There is no jwtToken for API');
    }

    if (!config.headers) {
      config.headers = new AxiosHeaders();
    }
    config.headers.Authorization = `Bearer ${jwtToken}`;

    return config;
  },
  error: (error: AxiosError) => {
    return Promise.reject(error);
  },
};

const createResponseInterceptor = (logPrefix: string) => ({
  success: (response: AxiosResponse) => response,
  error: (error: AxiosError) => {
    if (error.response?.status === 401) {
      const isLogged = Auth.isLogged();
      logger.error(
        `[${logPrefix} 401]: Token ${isLogged ? 'valid but unauthorized' : 'expired'}`,
      );

      if (!isLogged) {
        BusEvent.sendEvent({ event: EBusEvent.SILENT_REFRESH });
      }
    }

    return Promise.reject(error);
  },
});

export const apiResponseInterceptor = createResponseInterceptor('API');
export const hubResponseInterceptor = createResponseInterceptor('HUB');
